import React from 'react';
import AuthService from './authService';
import TpAdminItem from '../Domain/TpAdminItem';
import FreelancerUserManagerItem from '../Domain/FreelancerUserManagerItem';
import SearchParams from '../Elements/SearchParams';
import TpAdminSearchParams from '../Contents/ThirdParty/TpAdmin/TpAdminSearchParams';

export default class TpAdminService extends React.Component {
  static GetTpAdminItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      TpAdminSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/TpAdmin/GetItems?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpAdminItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertFreelancerDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new FreelancerUserManagerItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static GetTpAdminItemListForFreelancerUserEdit(freelancerUserId) {
    const url = `/api/TpAdmin/GetItemsForFreelancerUserEdit/${freelancerUserId}?clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async AddFreelancerUserManager(editedUser) {
    const url = 'api/TpAdmin/AddFreelancerUserManager';

    return AuthService.getInstance().CallBackendFunctionPost(url, editedUser);
  }

  static async RemoveFreelancerUserManager(id) {
    const url = `api/TpAdmin/RemoveFreelancerUserManager/${id}`;
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static async GetTpAdminForFreelancerUser(filter) {
    filter.FreelancerUserId = filter.FreelancerUserId <= 0 ? null : filter.FreelancerUserId;

    const url = `/api/TpAdmin/GetTpAdminsForFreelancerUserManagerEdit/?searchParams=${JSON.stringify(
      filter
    )}&clearCache=true`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetTpAdminByFreelancerUserId(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };

    const url = `/api/TpAdmin/GetTpAdminsByFreelancerUserId/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }
}
